import React, { useState } from "react";
import axios from "axios";
import { FaTimes, FaRupeeSign, FaRegTimesCircle } from "react-icons/fa";
import ConfirmModal from "./ConformModel/ConfirmModal";
import {
  useToast,
} from '@chakra-ui/react';
import UserDetailsModal from "./UserDetailsModal";
const WithdrawalDetailsModal = ({ withdrawal, onClose, refreshData }) => {
  const [loading, setLoading] = useState(false);
  const [showConfirm, setShowConfirm] = useState(false);
  const [selectedStatus, setSelectedStatus] = useState(withdrawal?.status);
  const [adminNotes, setAdminNotes] = useState("");
  const [userModalOpen, setUserModalOpen] = useState(false);
  const [userModalModel, setUserModalModel] = useState(null);
  const [userModalUserId, setUserModalUserId] = useState(null);

  const toast = useToast();


  if (!withdrawal) return null;

  const {
    user,
    amount,
    status,
    requestDate,
    processedAt,
    processedBy,
    reason,
    paymentMethodDetails,

  } = withdrawal;





  const handleUpdate = () => {
    setShowConfirm(true);
  };

  const confirmUpdate = async () => {
  try {
    setLoading(true);

    let res;

    // ✅ IF COMPLETED → call complete API
    if (selectedStatus === "COMPLETED") {
      res = await axios.post(
        `/api/v1/app/withdrawal/${withdrawal._id}/complete`,
        { adminNotes }
      );
    } 
    // ✅ OTHERWISE → normal status change
    else {
      const payload = {
        withdrawalId: withdrawal._id,
        status: selectedStatus,
        adminNotes,
      };

      res = await axios.post(
        `/api/v1/app/withdrawal/change-status`,
        payload
      );
    }

    if (res.data.status === "OK") {
      toast({
        title: "Withdrawal status updated",
        status: "success",
        duration: 3000,
        isClosable: true,
      });

      refreshData?.();
      onClose();
    }

  } catch (error) {
    const message =
      error?.response?.data?.message ||
      error?.response?.data?.error ||
      error?.message ||
      "Failed to update withdrawal status";

    toast({
      title: message,
      status: "error",
      duration: 3000,
      isClosable: true,
    });
  } finally {
    setLoading(false);
    setShowConfirm(false);
  }
};


  const formatDate = (date) =>
    date ? new Date(date).toLocaleString("en-GB", { hour12: true }) : "N/A";

  const getStatusColor = (status) => {
    // Use yellow accent for all status badges (Option A)
    return "px-2 py-1 rounded-full text-xs font-semibold flex items-center gap-1 bg-[var(--yellow)] text-[var(--black)] border-2 border-[var(--yellow)]";
  };

  const openUserProfile = async (u) => {
    if (!u) return;
    const id = u._id || u.id;
    if (!id) return;
    const baseModel = {
      name: u.fullName || u.name || u.email || u.phoneNumber || id,
      image: u.profileImage || u.image || u.avatar || "https://via.placeholder.com/150",
      gender: u.gender || "-",
      email: u.email,
      phone: u.phoneNumber,
    };
    setUserModalModel(baseModel);
    setUserModalUserId(id);
    setUserModalOpen(true);

    try {
      const res = await axios.get(`/api/v1/app/profile/${id}`);
      const p = res?.data?.data || {};
      const getAge = (dobStr) => {
        if (!dobStr) return undefined;
        const dob = new Date(dobStr);
        const diff = Date.now() - dob.getTime();
        const ageDt = new Date(diff);
        return Math.abs(ageDt.getUTCFullYear() - 1970);
      };
      const enriched = {
        name: p.fullName || p.name || baseModel.name,
        email: p.email || p.contactEmail || baseModel.email,
        phone: p.phoneNumber || p.phone || baseModel.phone,
        address: p.city || p.address || p.location?.city,
        latitude: p.coordinates?.latitude ?? p.location?.latitude,
        longitude: p.coordinates?.longitude ?? p.location?.longitude,
        age: getAge(p.dateOfBirth),
        dob: p.dateOfBirth ? new Date(p.dateOfBirth).toLocaleDateString() : undefined,
        gender: p.gender || baseModel.gender,
        role: p.role,
        lastActive: p.lastActive ? new Date(p.lastActive).toLocaleString() : undefined,
        accountCreated: p.createdAt ? new Date(p.createdAt).toLocaleString() : undefined,
        followers: Array.isArray(p.followers) ? p.followers.length : undefined,
        following: Array.isArray(p.following) ? p.following.length : undefined,
        friends: Array.isArray(p.friends) ? p.friends.length : undefined,
        image: p.profileImage || p.image || baseModel.image,
      };
      setUserModalModel((prev) => ({ ...prev, ...enriched }));
    } catch (e) {
      // ignore enrichment error
    }
  };
  return (
    <>
    <div className="fixed inset-0 bg-[var(--black)] flex justify-center items-center z-50 overflow-y-auto">
      <div className="bg-[var(--black)] rounded-xl shadow-lg w-full max-w-2xl mx-4 my-10 relative animate-fadeIn border-2 border-[var(--yellow)]">
        {/* Close Button */}
        <button
          onClick={onClose}
          className="absolute top-3 right-3 text-[var(--yellow)] hover:opacity-90"
        >
          <FaTimes size={20} />
        </button>

        {/* Header */}
        <div className="p-6 border-b border-[color:var(--yellow)/0.12]">
          <h2 className="text-2xl font-bold text-[var(--yellow)]">
            Withdrawal Request Details
          </h2>
        </div>

        {/* Content */}
        <div className="p-6 space-y-6 max-h-[80vh] overflow-y-auto text-[var(--yellow)]">
          {/* User Info */}
          <div>
            <h3 className="text-lg font-semibold text-[var(--yellow)] mb-3">
              User Information
            </h3>
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-x-6 gap-y-2 text-sm">
              <p>
                <span className="font-medium text-[var(--yellow)]">Full Name:</span>{" "}
                <span
                  className="text-blue-600 cursor-pointer hover:underline"
                  onClick={() => openUserProfile(user)}
                  role="button"
                  title="Open user profile"
                >
                  {user?.fullName || "N/A"}
                </span>
              </p>
              <p>
                <span className="font-medium text-[var(--yellow)]">Phone:</span>{" "}
                <span className="text-[var(--yellow)]">{user?.phoneNumber || "N/A"}</span>
              </p>
              <p>
                <span className="font-medium text-[var(--yellow)]">Current Balance:</span>{" "}
                <span className="text-[var(--yellow)]">₹{Math.round(withdrawal?.conversionSummary.availableBalance) ?? "N/A"}</span>
              </p>

            </div>
          </div>

          {/* Request Info */}
          <div>
            <h3 className="text-lg font-semibold text-[var(--yellow)] mb-3">
              Request Information
            </h3>
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-x-6 gap-y-2 text-sm">
              <p>
                <span className="font-medium text-[var(--yellow)]">Amount:</span>{" "}
                <span className="font-semibold flex items-center text-[var(--yellow)]">
                  <FaRupeeSign className="mr-1 text-[var(--yellow)]" />
                  {amount ?? "N/A"}
                </span>
              </p>
              <p className="flex items-center gap-2">
                <span className="font-medium text-[var(--yellow)]">Status:</span>
                <span className={getStatusColor(status)}>
                  {["REJECTED", "CANCELLED"].includes(status) && (
                    <FaRegTimesCircle className="text-[var(--black)] text-xs" />
                  )}
                  <span className="text-[var(--black)]">{status || "N/A"}</span>
                </span>
              </p>
              <p>
                <span className="font-medium text-[var(--yellow)]">Requested:</span>{" "}
                <span className="text-[var(--yellow)]">{formatDate(requestDate)}</span>
              </p>
              <p>
                <span className="font-medium text-[var(--yellow)]">Processed:</span>{" "}
                <span className="text-[var(--yellow)]">{formatDate(processedAt)}</span>
              </p>
              <p>
                <span className="font-medium text-[var(--yellow)]">Processed By:</span>{" "}
                <span className="text-[var(--yellow)]">{processedBy?.fullName || "N/A"}</span>
              </p>
              <p className="col-span-2">
                <span className="font-medium text-[var(--yellow)]">Reason:</span>{" "}
                <span className="text-[var(--yellow)]">{reason || "N/A"}</span>
              </p>
            </div>
          </div>

          {/* Payment Method */}

          <div>
            <h3 className="text-lg font-semibold text-[var(--yellow)] mb-3">
              Payment Method Details
            </h3>

            {paymentMethodDetails?.type === "UPI" && (
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-x-6 gap-y-2 text-sm">
                <p>
                  <span className="font-medium">Type:</span>{" "}
                  {paymentMethodDetails.type}
                </p>
                <p>
                  <span className="font-medium">UPI ID:</span>{" "}
                  {paymentMethodDetails.upiId || "N/A"}
                </p>
                <p>
                  <span className="font-medium">Upi Name:</span>{" "}
                  {withdrawal?.paymentMethod?.upi?.upiName || "N/A"}
                </p>
              </div>

            )}

            {paymentMethodDetails?.type === "BANK_ACCOUNT" && (
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-x-6 gap-y-2 text-sm">
                <p>
                  <span className="font-medium">Account Holder:</span>{" "}
                  {paymentMethodDetails.accountHolderName || "N/A"}
                </p>
                <p>
                  <span className="font-medium">Account Number:</span>{" "}
                  {paymentMethodDetails.accountNumber || "N/A"}
                </p>
                <p>
                  <span className="font-medium">IFSC Code:</span>{" "}
                  {paymentMethodDetails.ifscCode || "N/A"}
                </p>
                <p>
                  <span className="font-medium">Bank Name:</span>{" "}
                  {paymentMethodDetails.bankName || "N/A"}
                </p>
              </div>
            )}
          </div>




          {/* UPDATE BUTTON */}


          {withdrawal.status !== "COMPLETED" && (

            <>

              {/* === STATUS DROPDOWN === */}
              <div className="mt-6">
                <label className="font-medium block mb-2">Change Status</label>
                <select
                  className="w-full bg-white border border-[var(--yellow)] text-[var(--yellow)] px-3 py-2 rounded-lg"
                  value={selectedStatus}
                  onChange={(e) => setSelectedStatus(e.target.value)}
                >
                  <option value="PENDING">PENDING</option>
                  <option value="APPROVED">APPROVED</option>
                  <option value="REJECTED">REJECTED</option>
                  <option value="COMPLETED">COMPLETED</option>
                </select>
              </div>

              {/* === ADMIN NOTES FIELD === */}
              <div>
                <label className="font-medium block mb-2">Admin Notes (Optional)</label>
                <textarea
                  className="w-full bg-white border border-[var(--yellow)] text-[var(--yellow)] px-3 py-2 rounded-lg"
                  rows="3"
                  placeholder="Write notes..."
                  value={adminNotes}
                  onChange={(e) => setAdminNotes(e.target.value)}
                ></textarea>
              </div>

              <button
                disabled={loading}
                onClick={handleUpdate}
                className="px-4 py-2 bg-[var(--yellow)] text-[var(--black)] font-semibold rounded-lg hover:opacity-90"
              >
                {loading ? "Updating..." : "Update Status"}
              </button>

            </>


          )}
        </div>
      </div>
      <ConfirmModal
        isOpen={showConfirm}
        title="Update Status?"
        message="Are you sure you want to mark this withdrawal as COMPLETED?"
        block="Yes, Update"
        onConfirm={confirmUpdate}
        onCancel={() => setShowConfirm(false)}
      />

    </div>
      {userModalOpen && userModalModel && userModalUserId && (
        <UserDetailsModal
          model={userModalModel}
          userId={userModalUserId}
          onClose={() => setUserModalOpen(false)}
        />
      )}
    </>
  );
};

export default WithdrawalDetailsModal;
